import { CContainer } from '@coreui/react-pro'
import React from 'react'

const ConfiaCarContainer = (props) => {
  const { children } = props
  return <CContainer {...props}>{children}</CContainer>
}

export { ConfiaCarContainer }
